<template> 
<div>
    <div class="basic-2">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="text-container">
                        <h4 class="text-center" >درباره ما</h4>
                        <p class="p-large" style="text-align: justify">همانطور که میدانید پیشرفت تکنولوژی در سراسر دنیا علاوه بر افزایش سطح رفاه بشر، نوع زندگی و بسیاری از کسب و کارها را دستخوش تغییراتی کرده است. طوری که در خیلی کشور های پیشرفته اکثر کسب و کارها از شیوه سنتی خارج شده اند، و یا دست کم با تلفیق تکنولوژی به بقای خود کمک کرده اند. هدف تیم حرفه ای مشاوران وب کمک به کسب و کار های خرد و فردی و یا نوپا میباشد، تا بتوانند پا به دنیای دیجیتال گذاشته و قدمی به سوی کسب و کار حرفه ای بردارند. اگر هنوز شروع نکرده اید همین حالا با ما تماس بگیرید و بهترین پلن را برای شروع انتخاب کنید.</p>
                    </div> <!-- end of text-container -->

                </div> <!-- end of col -->
            </div> <!-- end of row -->
        </div> <!-- end of container -->
    </div> <!-- end of basic-2 -->
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>